// extracted by mini-css-extract-plugin
module.exports = {"block":"block--mMpK9","divider":"divider--GaMvw","button":"button--OHs9u","wrapper":"wrapper--9LkYv","loading":"loading--3mWag","container":"container--6qUxp","frame":"frame--bf-uT","frame_height":"frame_height--7uKhD","filler":"filler--RSTct","withGallery":"withGallery--MBZKt","gallery":"gallery--erbfW","active":"active--BV8Oc"};
    if(module.hot) {
      // 1653630380706
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  